import { Button } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCloseButton = styled(Button)`
  background: ${({ theme }) => theme.colors.button.close.background};
`;

export const StyledOptionBox = styled.div<{ isSelected: boolean }>`
  min-width: 100%;
  display: flex;
  align-items: start;
  padding: 1.8rem;
  border: 1px solid
    ${({ theme, isSelected }) => (isSelected ? theme.colors.statusTag.green.accent : theme.colors.border.light)};
  border-radius: ${({ theme }) => theme.radius.small};
  background: ${({ theme, isSelected }) => (isSelected ? theme.colors.background.active : 'transparent')};
  cursor: pointer;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    padding: 1.2rem;
  }
`;

export const StyledOptionTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  align-items: start;
  div {
    width: 100%;
  }
`;

export const StyledLighterText = styled.p<{ isDarkMode: boolean }>`
  color: ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.grey[500] : theme.colors.grey[900])};
`;

export const StyledCertificatePlaceholder = styled.img<{ isDarkMode: boolean }>`
  width: 100%;
  border: 1px solid ${({ theme, isDarkMode }) => (isDarkMode ? theme.colors.secondary.lighter : theme.colors.grey[300])};
  border-radius: ${({ theme }) => theme.radius.small};
  margin-top: 1.6rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 50rem;
    margin: 0 auto;
  }
`;

export const StyledLeftContainer = styled.div`
  width: 100%;
  max-width: 39.7rem;
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    max-width: 100%;
  }
`;
export const StyledRightContainer = styled.div`
  max-width: 24rem;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
    max-width: 100%;
  }
`;

export const StyledMainContainer = styled.div`
  display: flex;
  gap: 2.4rem;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  @media (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column;
  }
`;
